<template>
    <div class="uploadTheYear">
        <form action="" id="upload_yearCard">
            <div class="head-portrait">
                <label>{{$t("head_portrait")}}</label>
                <input id="pic1" type="hidden" value="" name="photo" class="image_photo">
                <!-- <img id="pic" src="../../assets/images/xuebi_18.png"> -->
                <img id="pic" :src="imgUrl?imgUrl:require('../../assets/images/xuebi_18.png')">
                <a href="javascript:;" class="file">
                    {{$t("upload_img")}}
                    <input type="file" name="" id="headPortraitUpload" @change="headPortraitListener($event)">
                </a>
                <span class="tag">{{$t("upload_detail")}}</span>
            </div>
            <!-- <label>年卡级别</label>
            <input type="text" value=""> -->
            <label>{{$t("compellation")}}</label>
            <input type="text" value="" :placeholder="$t('placeholder_real_name')" v-model="name1">
            <label>{{$t("idCard")}}</label>
            <input type="text" value="" :placeholder="$t('placeholder_idCard')" v-model="idCard1">
            <label>{{$t("compellation")}}</label>
            <input type="text" value="" :placeholder="$t('placeholder_real_name')" v-model="name2">
            <label>{{$t("idCard")}}</label>
            <input type="text" value="" :placeholder="$t('placeholder_idCard')" v-model="idCard2">
            <label>{{$t("compellation")}}</label>
            <input type="text" value="" :placeholder="$t('placeholder_real_name')" v-model="name3">
            <label>{{$t("idCard")}}</label>
            <input type="text" value="" :placeholder="$t('placeholder_idCard')" v-model="idCard3">
            <label>{{$t(" phone")}}</label>
            <input type="text" value="" :placeholder="$t('placeholder_phone')" v-model="tel">
        </form>
        <div class="confirm" @click="confirm()">{{$t("sure_submit")}}</div>
    </div>
</template>

<script>
export default {
  name: "uploadTheYear",
  data: function() {
    return {
      order_id: this.$route.query.order_id, //真实环境下是通过url获取真实的order_id
      goods_id: this.$route.query.goods_id, //真实环境下是通过url获取真实的goods_id
      order_sn: this.$route.query.order_sn, //真实环境下是通过url获取真实的order_sn
      rec_id: this.$route.query.rec_id,
      userInfo: "", //用户的信息，可能为空（在之前用户没有填写过相关信息的情况下）
      base64head: "", //定义全局变量存贮图片信息
      imgUrl: "",
      file: "",
      name1: "",
      idCard1: "",
      name2: "",
      idCard2: "",
      name3: "",
      idCard3: "",
      tel: "",
      regEn: /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
      regCn: /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im,
      regTel: /^[1][3,4,5,7,8][0-9]{9}$/
    };
  },
  inject: ["showMsg"],
  created: function() {
    this.getUserYearCardInfo();
    this.$store.commit("set_current", 6);
    this.$store.commit("set_title", "upload");
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  },
  methods: {
    // 当用户进入到填写年卡资料上传的页面时，如果用户之前已经填写过资料的话，就把资料数据渲染到现在的表单上
    getUserYearCardInfo: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Order/getUserInfo",
        dataType: "json",
        data: {
          order_id: this.order_id,
          goods_id: this.goods_id
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.userInfo = res.data.result;
            this.getUserYearCardInfoCb(res.data.result);
          }
        })
        .catch(() => {});
    },
    getUserYearCardInfoCb: function(info) {
      this.imgUrl = this.weburl + info.image;
      this.name1 = info.names[0].name;
      this.idCard1 = info.names[0].id_card;
      this.name2 = info.names[1].name;
      this.idCard2 = info.names[1].id_card;
      this.name3 = info.names[2].name;
      this.idCard3 = info.names[2].id_card;
      this.tel = info.tel;
    },
    headPortraitListener: function(e) {
      let file = e.target.files[0];
      this.file = file;
      let reader = new FileReader();
      let that = this;
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        that.base64head = reader.result;
        that
          .$http({
            xhrFields: {
              withCredentials: true
            },
            crossDomain: true,
            method: "post",
            url: that.weburl + that.hurl + "/order/imgSave",
            dataType: "json",
            data: { imgBase64: that.base64head }
          })
          .then(res => {
            // console.log(res);
            if (res.data.status === 1) {
              this.showMsg("图片上传成功");
              that.imgUrl = that.weburl + res.data.result;
            } else {
              this.showMsg(res.data.msg);
            }
          })
          .catch(() => {
            this.showMsg(this.$t("error_msg"));
          });
      };
    },
    confirm: function() {
      if (!this.imgUrl) {
        this.showMsg("请上传图片");
        return false;
      }
      if (!this.name1) {
        this.showMsg("请填写必填的姓名");
        return false;
      }
      if (!this.tel) {
        this.showMsg("手机号不能为空");
        return false;
      }
      if (!this.regTel.test(this.tel)) {
        this.showMsg("手机号格式不正确");
        return false;
      }
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/order/userInfo",
        dataType: "json",
        data: {
          order_id: this.order_id,
          goods_id: this.goods_id,
          order_sn: this.order_sn,
          rec_id: this.rec_id,
          names: [
            {
              name: this.name1,
              id_card: this.idCard1
            },
            {
              name: this.name2,
              id_card: this.idCard2
            },
            {
              name: this.name3,
              id_card: this.idCard3
            }
          ],
          tel: this.tel,
          headerImgUrl: this.base64head
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status === 1) {
            this.showMsg("提交成功");
            setTimeout(() => {
              this.$router.push({ path: "/personalCenter" });
            }, 1500);
          } else {
            this.showMsg(res.data.msg);
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";

.uploadTheYear {
  #upload_yearCard {
    width: @width;
    .box-sizing;
    padding: @font;
    label {
      display: inline-block;
      position: relative;
      width: 20%;
      line-height: 60px;
      text-align-last: justify;
      &:before {
        content: "*";
        top: -1px;
        left: -8px;
        font-size: @font;
        color: @brick_red;
      }
    }
    input {
      width: 75%;
      line-height: 55px;
      .border-bottom;
      margin-left: 3%;
    }
    .head-portrait {
      width: 100%;
      height: 5.5rem;
      line-height: 5.5rem;
      position: relative;
      & > img {
        position: absolute;
        top: 10px;
        left: 24%;
        width: 7.8rem;
        height: 5rem;
        margin: -1rem 0 0 0;
        .border-radius(10px);
        .border(1px, dashed, @brick_red);
        padding: 0.1rem;
        .box-sizing;
      }
      .file {
        float: right;
        position: relative;
        display: inline-block;
        width: 6.2rem;
        overflow: hidden;
        margin-top: 0.8rem;
        .btn;
        input {
          position: absolute;
          font-size: 100px;
          right: 0;
          top: 0;
          .img;
          opacity: 0;
        }
      }
      & > span {
        font-size: 0.4rem;
        color: @brick_red;
        position: absolute;
        bottom: -37px;
        left: 20%;
        transform: scale(0.9);
      }
    }
  }
  .confirm {
    .width;
    .btn;
  }
}
</style>
